import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-my-resource",
  "use": "icon-my-resource-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-my-resource\"><path d=\"M512 279.264L428.8 192H96v640h832V279.264z\" p-id=\"5597\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol